import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { VUE_APP_I18N_FALLBACK_LOCALE, VUE_APP_I18N_LOCALE } from '@/config/app-const'

Vue.use(VueI18n);

function loadLocaleMessages () {
    const translationFiles = require.context('./models', true, /[a-z0-9-_,\s]+\.[a-z0-9-_,\s]+\.js$/i);
    const messages = {};
    translationFiles.keys().forEach(key => {
        const matched = key.match(/([a-z0-9-_,\s]+)\.([a-z0-9-_,\s]+)\.js$/i);
        if (matched && matched.length > 1) {
            const module = matched[1];
            const locale = matched[2];
            messages[locale] = { ...messages[locale], ...translationFiles(key)[module][locale]};
        }
    });
    return messages
}

export default new VueI18n({
    locale: VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages : loadLocaleMessages()
})